import { createSlice } from '@reduxjs/toolkit';
import { getAdminUsers, getUsers } from './thunk';

export const initialState = {
  users: [],
  userList: [],
  userGrid: [],
  errors: {},
};

const UsersSlice = createSlice({
  name: 'Users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUsers.fulfilled, (state: any, action: any) => {
      state.users = action.payload;
    });
    builder.addCase(getAdminUsers.fulfilled, (state: any, action: any) => {
      // state.users = action.payload;
    });
  },
});

export default UsersSlice.reducer;
